export const environment = {
  production: false,
  MAIN_API_URL: "https://webapi-sta.011global.com",
  HUB_API_URL: "https://hub-sta.011global.com",
  RECAPTCHA_ENTERPRISE_SITE_KEY: "6LdltLUqAAAAANpd_zthLxt_wJa6Upbd_yCx1WEf",
  RECAPTCHA_TRANSACTION_SITE_KEY: '6LdLEWUrAAAAAJAoTB_oavCjnHnZzOU3ZxAw7hhJ',
};
